import React, { ReactElement } from 'react';
import { Box, style } from '@do/walrus';

const Title = ({ title }: { title?: string }): ReactElement => {
  return (
    <Box mb={style.vars.whitespace.small} display="block">
      <h3>{title}</h3>
    </Box>
  );
};

export default Title;
